import { AppRouter } from "./router/AppRouter"

export const SiscallApp = () => {
  return (
    <>
      <AppRouter />
    </>
  )
}
